import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import { Card, CardBody, CardTitle } from 'reactstrap';

import "../styles/dataTable.css"
import searchIcon from '../assets/images/search_icon.svg'
import addIcon from '../assets/images/add-icon.svg'
import arrowIcon from '../assets/images/Arrow.svg'
import upwardArrowIcon from '../assets/images/upward_arrow.svg'
import editIcon from '../assets/images/edit_icon.svg'

const ManageItinerary = () => {
  const navigate = useNavigate();
  const [itineraries, setItineraries] = useState([]);
  const [locations, setLocations] = useState([]);

  // Table
    const [search, setSearch] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    
    const filteredData = itineraries.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  
    if (sortField) {
      filteredData.sort((a, b) => {
        const valA = a[sortField];
        const valB = b[sortField];
        if (typeof valA === "number") {
          return sortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          return sortOrder === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }
      });
    }
  
    const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * entriesPerPage,
      currentPage * entriesPerPage
    );
  
    useEffect(() => {
      if (currentPage > totalPages) setCurrentPage(1);
    }, [search, entriesPerPage, totalPages]);
  
    // Sort Toggle Handler
    const handleSort = (field) => {
      if (sortField === field) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
    };

  useEffect(() => {
    fetchLocations()
    fetchItineraries();
  }, []);

  useEffect(() => {
    if (itineraries.length) {
      $('#itineraryTable').DataTable();
    }
  }, [itineraries]);

  const fetchItineraries = async () => {
    try {
      const response = await api.get('/itinerary/getall');
      setItineraries(response.data.data);
    } catch (error) {
      console.error('Error fetching itinerary data:', error);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await api.get('/location/get-all');
      setLocations(response.data.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/itineraries/${id}`);
      setItineraries(itineraries.filter(itinerary => itinerary.id !== id));
      alert(`Itinerary with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting itinerary:', error);
      alert('Error deleting itinerary');
    }
  };

  const handleCreateItineraryClick = () => {
    navigate("/create-itinerary");
  };

  const handleItineraryUpdate = (cardid, locationid) => {
    navigate(`/update-itinerary/${cardid}/${locationid}`);
  };

  // console.log(itineraries.map( el => Array.isArra(el.dates)))

  return (
    <div style={{position: 'relative', height:  'auto',  }}>
      <div style={{ padding: "20px",  }}>
              {/* Table Header */}
              <div className="table-header">
                    <h2 style={{fontWeight: 700,}}>Manage Itinerary</h2>
      
                    <div className="search-container">
                        <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                        placeholder="search"
                        />
                        <img src={searchIcon} alt="search-icon" className="search-icon" />
                    </div>
      
                    <div className="entries-container">
                        <label htmlFor="noOfEntries">Show: </label>
                        <select
                            value={entriesPerPage}
                            id="noOfEntries"
                            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                        >
                            <option value={10}>10 Entries per page </option>
                            <option value={50}>50 Entries per page</option>
                            <option value={100}>100 Entries per page</option>
                        </select>
                    
                    </div>
      
                    <div className="action-btn">
                        <button onClick={handleCreateItineraryClick}>
                          <img src={addIcon} alt="add-icon" />  Add itinerary
                        </button>
                    </div>
      
                </div>
      
                  {/* Table */}
              <table width="100%" cellPadding="20" className="table-no-outer-border">
                <thead>
                  <tr>
                    <th>
                      Sr. No. 
                    </th>
                    <th onClick={() => handleSort("name")}>
                      <div className='name-container'>
                        Package Name 
                        <div className='sort-arrow-container'>
                          <img src={upwardArrowIcon} alt="upward-arrow"
                            style={ {opacity: sortField === "name" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                          />
                          <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                            opacity: sortField === "name" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                          }} />
                        </div>
                      </div>
                    </th>
                    <th onClick={() => handleSort("email")}>
                      <div className='name-container'>
                        Location 
                        <div className='sort-arrow-container'>
                          <img src={upwardArrowIcon} alt="upward-arrow"
                            style={ {opacity: sortField === "email" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                          />
                          <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                            opacity: sortField === "email" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                          }} />
                        </div>
                      </div>
                    </th>
                    <th onClick={() => handleSort("mobile")}>
                      <div className='name-container'>
                        Date 
                        <div className='sort-arrow-container'>
                          <img src={upwardArrowIcon} alt="upward-arrow"
                            style={ {opacity: sortField === "mobile" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                          />
                          <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                            opacity: sortField === "mobile" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                          }} />
                        </div>
                      </div>
                    </th>
                    {/* <th>Image</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row, i) => {
                      const srNo = (currentPage - 1) * entriesPerPage + i + 1;
                      return(
                        <tr key={row.id}>
                          <td>{srNo}</td>
                          <td>{row.packagename}</td>
                          {/* <td>{locations.filter((location) => location.id === row.location_id)[0]?.location}</td> */}
                          <td>{row.locationname}</td>
                          <td>{row.dates}</td>
                         
                          <td className='text-center align-middle'>
                          
      
                              <button className='edit-button' onClick={() => handleItineraryUpdate(row.cardid, row.locid)}>
                                <img src={editIcon} alt="editIcon" />
                                Edit
                              </button>
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center" }}>
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
      
              {/* Pagination */}
              
                <div style={{paddingBottom: '30px', background: '#fff'}}>
                  <div style={{ padding: "30px", textAlign: "center", borderTop: '2px solid #F2F2F2',borderBottom: '2px solid #F2F2F2'}}>
                    {/* Prev arrow */}
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        style={{
                        margin: "0 5px",
                        padding: "5px 10px",
                        background: "#fff",
                        border: "none",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        color: currentPage === 1 ? "#ccc" : "#000"
                        }}
                    >
                      <img src={arrowIcon} alt="arrow-icon"
                        style={{
                          opacity: currentPage === 1 ? "0.5" : "1",
                        }}
                      />
      
                    </button>
      
                    {/* Page Numbers */}
                    {(() => {
                        const pageButtons = [];
                        const maxVisiblePages = 4;
      
                        if (totalPages <= maxVisiblePages + 1) {
                        // Show all pages if total pages is small
                        for (let i = 1; i <= totalPages; i++) {
                            pageButtons.push(i);
                        }
                        } else {
                        if (currentPage <= maxVisiblePages) {
                            // Show first 4 pages and last
                            for (let i = 1; i <= maxVisiblePages; i++) {
                            pageButtons.push(i);
                            }
                            pageButtons.push('...', totalPages);
                        } else if (currentPage > totalPages - maxVisiblePages) {
                            // Show first, ..., last 4 pages
                            pageButtons.push(1, '...');
                            for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
                            pageButtons.push(i);
                            }
                        } else {
                            // Middle section: 1, ..., current-1, current, current+1, ..., last
                            pageButtons.push(1, '...');
                            pageButtons.push(currentPage - 1, currentPage, currentPage + 1);
                            pageButtons.push('...', totalPages);
                        }
                        }
      
                        return pageButtons.map((page, index) => {
                        if (page === '...') {
                            return (
                            <span key={`ellipsis-${index}`} style={{ margin: "0 5px" }}>...</span>
                            );
                        }
      
                        return (
                            <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            style={{
                                margin: "0 5px",
                                padding: "5px 10px",
                                background: currentPage === page ? "#D9D9D9" : "#fff",
                                color: currentPage === page ? "black" : "#00000075",
                                border: "none",
                                cursor: "pointer",
                            }}
                            >
                            {page}
                            </button>
                        );
                        });
                    })()}
      
                    {/* Next arrow */}
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        style={{
                        margin: "0 5px",
                        padding: "5px 10px",
                        background: "#fff",
                        border: "none",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                        color: currentPage === totalPages ? "#ccc" : "#000"
                        }}
                    >
                        <img src={arrowIcon} alt="arrow-icon"
                          style={{
                            opacity: currentPage === totalPages ? "0.5" : "1",
                            transform: 'rotateY(180deg)'
                          }}
                        />
                    </button>
                  </div>
                </div>
      
            </div>



    </div>
  );
};

export default ManageItinerary;
